import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { MaskedLines } from "./Reveal";

export const PageHero = ({ eyebrow, titleLines, subtitle, image, breadcrumb = [] }) => (
  <section className="relative bg-slate-50 pt-36 pb-20 overflow-hidden" data-testid="page-hero">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-50 via-slate-50/85 to-slate-50/40" />
      </div>
    )}
    <div className="absolute -top-32 -right-32 h-[400px] w-[400px] rounded-full bg-blue-500/10 blur-[100px] pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10">
      <nav className="flex items-center gap-2 text-xs text-slate-500 mb-8" data-testid="breadcrumb">
        <Link to="/" className="hover:text-blue-700">Start</Link>
        {breadcrumb.map((b, i) => (
          <span key={i} className="flex items-center gap-2">
            <ChevronRight className="h-3 w-3" />
            {b.to ? <Link to={b.to} className="hover:text-blue-700">{b.label}</Link> : <span className="text-blue-700">{b.label}</span>}
          </span>
        ))}
      </nav>
      {eyebrow && <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">{eyebrow}</p>}
      <h1 className="text-navy-900 font-heading font-semibold tracking-tight leading-[1.12] text-4xl sm:text-6xl max-w-4xl pb-1">
        <MaskedLines lines={titleLines} />
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-6 max-w-xl text-lg text-slate-600 font-light leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
